/* @flow */
/**
 * External dependencies
 */
import React from 'react';
import styled from 'styled-components';

/**
 * Style
 */
const ScreenReaderText = styled.span`
	border: 0;
	clip: rect(1px, 1px, 1px, 1px);
	clip-path: inset(50%);
	height: 1px;
	margin: -1px;
	overflow: hidden;
	padding: 0;
	position: absolute;
	width: 1px;
	word-wrap: normal !important;
`;

export default ( { children } : { children: string } ) => (
	<ScreenReaderText>{ children }</ScreenReaderText>
);



// WEBPACK FOOTER //
// ./src/components/screen-reader-text/index.js